import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Bannerコンポーネントのバリアント定義
 *
 * Figmaデザイン: https://www.figma.com/design/K9BryoBh0t69xPihm3VBho/【DnR】DesignSystem?node-id=2392-48724
 */
export const bannerVariants = cva(
  'flex items-center gap-4 rounded-lg border border-border-base p-4 w-full',
  {
    variants: {
      type: {
        neutral: 'bg-surface',
        error: 'bg-surface-error',
        warning: 'bg-surface-warning',
        info: 'bg-surface-info',
      },
    },
    defaultVariants: {
      type: 'neutral',
    },
  },
);

export type BannerType = 'neutral' | 'error' | 'warning' | 'info';

export type BannerVariantProps = VariantProps<typeof bannerVariants>;
